import { OrganizationKeyName } from "../../../model/Organization";

export const UPDATE_PRODUCT_CATEGORY_ORDER =
  "SHOP:UPDATE_PRODUCT_CATEGORY_ORDER";

export const updateProductCategoryOrderAction = (
  organization: OrganizationKeyName,
  data: string[]
) => ({
  type: UPDATE_PRODUCT_CATEGORY_ORDER as typeof UPDATE_PRODUCT_CATEGORY_ORDER,
  organization,
  data,
});

export type UpdateProductCategoryOrderAction = ReturnType<
  typeof updateProductCategoryOrderAction
>;
